(function () {
  'use strict';

  angular.module('sempraWebapp').factory('DashboardFinancesViewModel', dashboardFinancesViewModelFactory);

  /** @ngInject */
  function dashboardFinancesViewModelFactory (modelUtils, dailyFinancesStore, FinancesTileViewModel) {
    function DashboardFinancesViewModel (financesJson) {
      this.finances = [];
      this.totalMoney = 0;
      this.ecomAmount = 0;
      this.currencyCode = '';

      init.call(this, financesJson);
    }

    DashboardFinancesViewModel.prototype.destroy = function () {
      this.finances.forEach(function (financeTileViewModel) {
        financeTileViewModel.destroy();
      });
    };

    DashboardFinancesViewModel.prototype.refreshTileFinances = function (refreshData) {
      var that = this;
      var tileViewModel = this.finances.find(function (financesViewModel) {
        return financesViewModel.deviceSerial === refreshData.facility.deviceSerial;
      });

      if (tileViewModel) {
        tileViewModel.refreshFinances(refreshData.facility);
      }

      //this.totalMoney = refreshData.total;
      this.totalMoney = 0;
      this.finances.forEach(function (financesTileViewModel) {
        that.totalMoney += financesTileViewModel.totalPayments;
      });
    };

    DashboardFinancesViewModel.prototype.refreshTileDevice = function (refreshData) {
      var tileViewModel = this.finances.find(function (financesViewModel) {
        return financesViewModel.deviceSerial === refreshData.path;
      });

      if (tileViewModel) {
        tileViewModel.refreshDevice(refreshData);
      }
    };

    return DashboardFinancesViewModel;

    function init (dailyFinancesData) {
      if (dailyFinancesData === null) {
        return;
      }
      this.totalMoney = dailyFinancesData.total;
      this.ecomAmount = dailyFinancesData.ecomAmount;
      this.currencyCode = dailyFinancesData.currency;
      this.finances = [];
      dailyFinancesData.facilities.forEach(function (dailFinancesJson) {
        this.push(new FinancesTileViewModel(dailFinancesJson));
      }, this.finances);
    }
  }
})();
